import React from 'react';
import { CancelWithSupport } from '@/components/billing/subscriptions/CancelWithSupport';
import { CANCEL_RENEWAL_FLOW_HUMAN_SUPPORT } from '@/config/GrowthBook/constants';

const CancelRenewalWithSupportPage = () => (
  <CancelWithSupport
    featureFlag={CANCEL_RENEWAL_FLOW_HUMAN_SUPPORT}
    zendeskTag="hgbr_chat_retencao_renovacao_a_b"
    redirectRoute="cancelRenewal"
  />
);

export default CancelRenewalWithSupportPage;
